<template>
  <transition name="fade">
    <div v-if="isVisible" class="modal is-active">
      <div class="modal-background"></div>
      
      <div class="modal-content">
        <div class="box has-text-centered">
          <div class="cookie-content">
            <p class="block">
              Ce site utilise uniquement des cookies strictement nécessaires à son fonctionnement.
              Aucune donnée à caractère personnel n’est collectée.
              <span class="second-part">En cliquant sur « Continuer », vous confirmez avoir été informé et acceptez leur utilisation.</span>
            </p>
            
            <button @click="dismissBanner" class="button is-primary is-fullwidth">
              <strong>
                <awesome-icon class="button-icon" icon="check"/> Continuer
              </strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const isVisible = ref(false);

onMounted(() => {
  const hasDismissed = localStorage.getItem('cookie_dismissed');
  if (!hasDismissed) {
    isVisible.value = true;
  }
});

const dismissBanner = async () => {
  isVisible.value = false;
  localStorage.setItem('cookie_dismissed', 'true');
};
</script>

<style scoped>
/* stay on top of everything */
.modal {
  z-index: 10000;
}

.cookie-content {
  padding: 1rem;
}

.block {
  font-size: 1.1rem;
}

.second-part {
  display: block;
  margin-top: 0.25rem;
}

.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-leave-to {
  opacity: 0;
}
</style>